import React from 'react';
import { Row, Content, Message } from 'components/lib';
import { useEffect } from 'react';

export function InternalError(props) {

    useEffect(() => {
        document.title = props.t('error.500.title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Row>
            <Content>
                <Message
                    type='error'
                    title={props.t('error.500.title')}
                    text={props.t('error.500.text')}
                    buttonText={props.t('error.500.button')}
                    buttonLink='/navigate'
                />
            </Content>
        </Row>
    );
}